const financialModelingPrepApiKey = process.env.REACT_APP_FMP_API_KEY
const eodHistorialApiKey = process.env.REACT_APP_EOD_API_KEY

export {financialModelingPrepApiKey,eodHistorialApiKey}